import { render, staticRenderFns } from "./ModuleEditSlidebar.vue?vue&type=template&id=441faf21"
import script from "./ModuleEditSlidebar.vue?vue&type=script&lang=js"
export * from "./ModuleEditSlidebar.vue?vue&type=script&lang=js"
import style0 from "./ModuleEditSlidebar.vue?vue&type=style&index=0&id=441faf21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports